import React, { useContext } from 'react';
import { StyledFullscreenButton } from './FullscreenButton.styled';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import { ExitFullscreen, Fullscreen } from '@styled-icons/boxicons-regular';

export default function FullscreenButton({ onExit, parentDivRef }) {
  const fullscreenContext = useContext(FullscreenContext);

  return (
    <StyledFullscreenButton
      onClick={(event) => {
        if (fullscreenContext.state.isFullscreen && onExit) {
          onExit();
        }
        fullscreenContext.actions.setFullscreen(
          !fullscreenContext.state.isFullscreen
        );
        event.target?.blur();
        parentDivRef?.current?.focus();
      }}
      size="small"
      className={`fullscreen-button ${
        fullscreenContext.state.isFullscreen ? 'active' : ''
      }`}
    >
      {fullscreenContext.state.isFullscreen ? (
        <ExitFullscreen size={20} />
      ) : (
        <Fullscreen size={18} />
      )}
    </StyledFullscreenButton>
  );
}
